import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { CheckCircle, ArrowRight, Download, Calendar } from 'lucide-react';
import { trackPageView } from '../lib/ga4';

const MerciPage = () => {
  useEffect(() => {
    trackPageView('/merci', 'Merci - Demande envoyée');
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4" data-testid="merci-page">
      <div className="max-w-lg w-full">
        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-gray-200 text-center">
          {/* Success icon */}
          <div className="flex justify-center mb-6">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center">
              <CheckCircle className="w-12 h-12 text-green-600" />
            </div>
          </div>

          {/* Title */}
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Merci pour votre demande !
          </h1>

          {/* Message */}
          <p className="text-gray-600 mb-8 leading-relaxed">
            Nous avons bien reçu votre demande d'accompagnement. 
            Un expert de notre équipe vous contactera sous <strong>24 heures</strong> pour 
            discuter de votre projet.
          </p>

          {/* What's next */}
          <div className="bg-gray-50 rounded-xl p-6 mb-8 text-left">
            <h2 className="font-semibold text-gray-900 mb-4">Prochaines étapes :</h2>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-blue-700 text-sm font-bold">1</span>
                </div>
                <span className="text-gray-700 text-sm">
                  Nous analysons votre demande et préparons un premier échange
                </span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-blue-700 text-sm font-bold">2</span>
                </div>
                <span className="text-gray-700 text-sm">
                  Appel découverte de 30 minutes pour comprendre vos besoins
                </span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-blue-700 text-sm font-bold">3</span>
                </div>
                <span className="text-gray-700 text-sm">
                  Proposition d'accompagnement personnalisée sous 48h
                </span>
              </li>
            </ul>
          </div>

          {/* Actions */}
          <div className="space-y-3">
            <Link to="/rapport" className="block" data-testid="merci-rapport-link">
              <Button className="w-full bg-blue-700 hover:bg-blue-800 text-white rounded-full py-3">
                <Download className="w-5 h-5 mr-2" />
                Télécharger notre rapport IA PME
              </Button>
            </Link>
            <Link to="/" className="block" data-testid="merci-home-link">
              <Button variant="outline" className="w-full rounded-full py-3">
                Retour à l'accueil
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
            </Link>
          </div>

          {/* Contact */}
          <p className="mt-8 text-sm text-gray-500">
            Une question ? Contactez-nous à{' '}
            <a href="mailto:contact@acdc-formation.fr" className="text-blue-700 hover:underline">
              contact@acdc-formation.fr
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default MerciPage;
